@let barState = state();
@let copy = copyContext();

<ng-template #scopeSentence>
  @switch (barState.kind) {
    @case ('allMatching') {
      @if (allMatchingTemplate()) {
        <ng-container [ngTemplateOutlet]="allMatchingTemplate()!" [ngTemplateOutletContext]="copy" />
      } @else if (barState.totalKnown) {
        {{ 'GALAXY.TABLE.SELECTION_BAR.ALL_MATCHING' | translate: { total: copy.totalLabel } }}
      } @else {
        {{ 'GALAXY.TABLE.SELECTION_BAR.ALL_MATCHING_UNKNOWN' | translate }}
      }
    }
    @case ('capReached') {
      @if (copy.totalKnown) {
        {{ 'GALAXY.TABLE.SELECTION_BAR.CAP_REACHED' | translate: { count: copy.countLabel, total: copy.totalLabel } }}
      } @else {
        {{ 'GALAXY.TABLE.SELECTION_BAR.CAP_REACHED_UNKNOWN' | translate: { count: copy.countLabel } }}
      }
    }
    @default {
      @if (pageScopeTemplate()) {
        <ng-container [ngTemplateOutlet]="pageScopeTemplate()!" [ngTemplateOutletContext]="copy" />
      } @else if (copy.totalKnown) {
        {{ 'GALAXY.TABLE.SELECTION_BAR.PAGE_SCOPE' | translate: { count: copy.countLabel, total: copy.totalLabel } }}
      } @else {
        {{ 'GALAXY.TABLE.SELECTION_BAR.PAGE_SCOPE_UNKNOWN' | translate: { count: copy.countLabel } }}
      }
    }
  }
</ng-template>

<span class="selection-announcement" data-testid="selection-announcement" role="status" aria-live="polite">
  @if (barState.kind !== 'hidden') {
    <ng-container [ngTemplateOutlet]="scopeSentence" />
  }
</span>

@if (barState.kind !== 'hidden') {
  <div class="bar-collapse">
    <div
      class="glxy-table-selection-bar"
      [class.glxy-table-selection-bar--all-matching]="barState.kind === 'allMatching'"
    >
      <span class="selection-scope" data-testid="selection-scope" aria-hidden="true">
        <ng-container [ngTemplateOutlet]="scopeSentence" />
      </span>

      @if (barState.kind !== 'allMatching' && barState.canEscalate) {
        <button
          matButton="outlined"
          class="select-all-prompt"
          data-testid="select-all-prompt"
          data-action="clicked-glxy-table-select-all"
          (click)="onSelectAll()"
        >
          @if (selectAllPromptTemplate()) {
            <ng-container [ngTemplateOutlet]="selectAllPromptTemplate()!" [ngTemplateOutletContext]="copy" />
          } @else if (barState.kind === 'capReached') {
            @if (barState.totalKnown) {
              {{ 'GALAXY.TABLE.SELECTION_BAR.SELECT_ALL_INSTEAD' | translate: { total: copy.totalLabel } }}
            } @else {
              {{ 'GALAXY.TABLE.SELECTION_BAR.SELECT_ALL_INSTEAD_UNKNOWN' | translate }}
            }
          } @else if (barState.totalKnown) {
            {{ 'GALAXY.TABLE.SELECTION_BAR.SELECT_ALL_PROMPT' | translate: { total: copy.totalLabel } }}
          } @else {
            {{ 'GALAXY.TABLE.SELECTION_BAR.SELECT_ALL_PROMPT_UNKNOWN' | translate }}
          }
        </button>
      }

      @if (!hideActionButton()) {
        <button
          matButton="outlined"
          class="table-btn actions-trigger"
          data-testid="actions-trigger"
          data-action="clicked-glxy-table-actions"
          [matMenuTriggerFor]="actionsMenu"
        >
          <span class="table-btn-icon"><mat-icon>flash_on</mat-icon></span>
          <span>
            @if (barState.kind === 'allMatching') {
              @if (barState.totalKnown) {
                {{ 'GALAXY.TABLE.SELECTION_BAR.ACTIONS_ON_ALL' | translate: { total: copy.totalLabel } }}
              } @else {
                {{ 'GALAXY.TABLE.SELECTION_BAR.ACTIONS_ON_ALL_UNKNOWN' | translate }}
              }
            } @else {
              {{ 'GALAXY.TABLE.SELECTION_BAR.ACTIONS_ON_COUNT' | translate: { count: copy.countLabel } }}
            }
          </span>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <ng-content select="[mat-menu-item]" />
        </mat-menu>
        <span class="bar-divider"></span>
      }

      <button
        mat-button
        class="clear-selection"
        data-testid="clear-selection"
        [attr.aria-label]="'GALAXY.TABLE.SELECTION_BAR.CLEAR' | translate"
        (click)="onClear()"
      >
        <mat-icon>close</mat-icon>
        <span class="clear-label">{{ 'GALAXY.TABLE.SELECTION_BAR.CLEAR' | translate }}</span>
      </button>
    </div>
  </div>
}
